'use strict';

var base = require('../product/base');
var location = window.location;
var toastMessageHelper = require('../utils/toastMessageHelper');

var isPickUpFromShowroomRequestActive = false;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
                + 'fade show" role="alert">'
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<span aria-hidden="true">&times;</span>'
                + '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            // Removed default empty cart message

            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.mini-cart-total-items').empty().append(data.numItems);
    $('.mini-cart-lineitem-count').empty().append(data.lineItemsCount);
    $('.carttile-count').empty().append().append(data.lineItemsCount);
    $('.line-item-count').empty().append().append(data.lineItemsCount);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- '
            + data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        $('.line-item-total-' + item.UUID + ' .total-price').empty().append(item.priceTotal.adjustedGrossPrice);
        $('.line-item-total-' + item.UUID + ' .strike-through').empty().append(item.priceTotal.nonAdjustedGrossPrice);
        $('.discount-price').removeClass('d-inline-flex').addClass('d-none');
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i += 1) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i += 1) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}
/**
 * Updates the content of the modal based on the provided action type and product information.
 *
 * This function updates the modal buttons with appropriate product data, replaces the placeholder
 * in the message with the product name, and dynamically updates the modal body text.
 *
 * @param {string} actionUrl - The URL used to perform the action, such as moving the product to the wishlist or removing it from the cart.
 * @param {string} productID - The unique identifier of the product (PID).
 * @param {string} productName - The name of the product to be displayed in the modal message.
 * @param {string} uuid - A unique identifier for the user session or request, used to track actions.
 * @param {string} resourceMsg - The message template with a placeholder `{0}` to be replaced with the product name.
 * @param {string} modalType - Specifies the type of modal ('removeProduct' or 'moveProduct'), which determines the button and message layout.
 *
 * @returns {void} - No return value. The function updates the modal content directly in the DOM.
 */
function updateModalContent(actionUrl, productID, productName, uuid, resourceMsg, modalType) {
    // Determine button and bodyText based on the modalType
    var $btn = (modalType === 'removeProduct') ? $('.cart-delete-confirmation-btn') : $('.move-to-wishlist-btn');
    var $bodyText = (modalType === 'removeProduct') ? $('.delete-confirmation-body .body-text') : $('.move-to-wishlist-text .body-text');

    // Set the data for the button
    $btn.data({
        pid: productID,
        action: actionUrl,
        uuid: uuid
    });

    // Handle additional logic for the 'removeProduct' action
    if (modalType === 'removeProduct') {
        var $btn1 = $('#removeProductModal .move-to-wishlist-btn');
        $btn1.data({
            pid: productID,
            action: actionUrl,
            uuid: uuid
        });
    }

    var displayName = (modalType === 'removeProduct')
        ? '<strong>' + productName + '</strong>'
        : productName;

    var msg = resourceMsg.replace('{0}', displayName);
    $bodyText.empty().append(msg);
}

/**
 * Handles the setup of modal content when a user initiates an action (e.g., remove product or move to wishlist).
 *
 * This function extracts necessary product and action data from the clicked element and passes them
 * to the `updateModalContent` function to dynamically populate the appropriate modal.
 *
 * @param {jQuery} $element - The jQuery-wrapped DOM element that was clicked to trigger the modal.
 * @param {string} modalType - The type of modal to display ('removeProduct' or 'moveProduct'),
 *                             used to determine which modal and message to update.
 */
function handleModalAction($element, modalType) {
    var actionUrl = $element.data('action');
    var productID = $element.data('pid');
    var productName = $element.data('name');
    var uuid = $element.data('uuid');
    var resourceMsg = (modalType === 'removeProduct')
        ? $('#removeProductModal .resource-mSg').val()
        : $('#moveProductToWishlistModal .resource-mSg').val();

    updateModalContent(actionUrl, productID, productName, uuid, resourceMsg, modalType);
}
module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();
        handleModalAction($(this), 'removeProduct');
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e, message) {
        e.preventDefault();

        const isGlobalDelete = $('#removeProductModal').data('globalDelete');
        var selectedItems = [];

        if (isGlobalDelete === true) {
            $('.cartdetails .toggle-pli-select:checked').each(function (ind, el) {
                var options = $(this).attr('data-option-product') || [];
                var optionProductAttrJSON = $(this).attr('data-option-details');
                var optionProductAttr = optionProductAttrJSON ? JSON.parse(optionProductAttrJSON) : {};

                var payload = {
                    pid: $(el).data('pid'),
                    uuid: $(el).data('uuid'),
                    quantity: $(el).data('quantity'),
                    options
                };

                Object.assign(payload, optionProductAttr);

                selectedItems.push(payload);
            });
            $(document).trigger('cart:deleteMultiplePLI', JSON.stringify(selectedItems));
            return;
        }

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.productListAction) {
                    $.spinner().stop();
                } else if (data.basket.items.length === 0) {
                    var $modal = $('.size-guide-modal');
                    if ($modal.length) {
                        $modal.find('.go-to-cart-btn').addClass('d-none');
                        $modal.find('.add-to-cart').removeClass('d-none');
                    }
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i += 1) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                var toastMessage = $('#removedFromCart').val();
                toastMessageHelper.showNotification(message || toastMessage);
                $('body').trigger('cart:update', data);

                $.spinner().stop();
                location.reload();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    toastMessageHelper.showNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    // Handle Decrease Quantity
    $('body').on('click', '.mini-click', function (e) {
        e.preventDefault();
        var $input = $(this).siblings('.quantity');
        var quantity = parseInt($input.val(), 10);
        var minPurchaseQty = parseInt($(this).data('qty-min'), 10);

        if (quantity > minPurchaseQty) {
            quantity--;
            $input.val(quantity);

            $input.trigger('change');
        }
    });

    // Handle Increase Quantity
    $('body').on('click', '.max-click', function (e) {
        e.preventDefault();
        var $input = $(this).siblings('.quantity');
        var quantity = parseInt($input.val(), 10);
        var maxPurchaseQty = parseInt($(this).data('qty-max'), 10);

        if (quantity < maxPurchaseQty) {
            quantity++;
            $input.val(quantity);

            $input.trigger('change');
        }
    });

    $('body').on('input', '.quantity-form > .quantity', function () {
        var $input = $(this);
        if ($input.val().length > 3) {
            $input.val($input.val().slice(0, 3));
        }
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var $input = $(this);
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var minPurchaseQty = parseInt($input.data('qty-min'), 10);
        var maxPurchaseQty = parseInt($input.data('qty-max'), 10);

        if (quantity < minPurchaseQty || quantity > maxPurchaseQty) {
            if (quantity > maxPurchaseQty) {
                $(this).closest('.product-info').find('.max-limit-error').removeClass('d-none');
                $input.val(maxPurchaseQty);
                $(this).siblings('.mini-click').prop('disabled', false);
                $(this).siblings('.max-click').prop('disabled', true);
            } else {
                $input.val(preSelectQty);
            }
            return;
        }
        $input.data('pre-select-qty', quantity);

        if (quantity <= minPurchaseQty) {
            $(this).siblings('.mini-click').prop('disabled', true);
        } else {
            $(this).siblings('.mini-click').prop('disabled', false);
        }

        if (quantity >= maxPurchaseQty) {
            $(this).siblings('.max-click').prop('disabled', true);
            $(this).closest('.product-info').find('.max-limit-error').removeClass('d-none');
        } else {
            $(this).siblings('.max-click').prop('disabled', false);
            $(this).closest('.product-info').find('.max-limit-error').addClass('d-none');
        }

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        if ($('.page').data('action') === 'Cart-Show') {
            $.spinner().start();
        }
        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);
                $('#maincontent').trigger('cart:refreshCartSummary');
                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
                if ($('.page').data('action') === 'Cart-Show') {
                    window.location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('keypress', '.quantity-form > .quantity', function (t) {
        // Allow only digits (key codes 48-57 for 0-9)
        if (t.keyCode < 48 || t.keyCode > 57) {
            t.preventDefault();
        }
    });

    $('body').on('submit', '.promo-code-form', function (e) {
        e.preventDefault();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                var ecomCouponCodeApplied = false;
                if (!data.error && data.totals.ecomCouponAdjustmentAmount && data.totals.ecomCouponAdjustmentAmount.length > 0) {
                    $('.coupon-discount-row.applied').empty();
                    $.each(data.totals.ecomCouponAdjustmentAmount, function (index, coupon) {
                        if (coupon.applied) {
                            ecomCouponCodeApplied = true;
                        }
                        var $couponCard = $('<div>', {
                            class: 'discount-voucher-card coupon-price-adjustment coupon-uuid-' + coupon.externalAdjustmentId,
                            'data-code': coupon.externalAdjustmentId
                        });

                        // Left
                        var $voucherLeft = $('<div>', { class: 'voucher-left position-relative' })
                            .append('<div class="left-circle position-absolute"></div>')
                            .append('<div class="voucher-icon"><svg class="discount-voucher-icon" height="20" width="20"><use xlink:href="#vouchers-discount-icon"></use></svg></div>');

                        // Middle
                        var $voucherMiddle = $('<div>', { class: 'voucher-middle' })
                            .append($('<p>', { class: 'voucher-code coupon-code-name', text: coupon.externalAdjustmentId }))
                            .append($('<p>', { class: 'voucher-label', text: 'PROMO CODE' }));

                        // Right
                        var $voucherRight = $('<div>', { class: 'voucher-right position-relative' })
                            .append('<div class="right-circle position-absolute"></div>');

                        var $valueSection = $('<div>', { class: 'voucher-value-section' })
                            .append($('<p>', { class: 'voucher-value-label', text: 'Value' }))
                            .append($('<p>', { class: 'voucher-value coupon-code-price', text: data.currencySymbol + coupon.amountApplied }));

                        var $removeButton = $('<button>', {
                            type: 'button',
                            class: 'voucher-remove remove-coupon',
                            'data-code': coupon.externalAdjustmentId,
                            'data-uuid': coupon.couponUUID,
                            'data-action': data.actionUrls.removeCouponLineItem,
                            html: `<svg class="tiles-close-icon d-lg-none" height="10" width="10"><use xlink:href="#discount-tiles-close-icon"></use></svg> <svg class="tiles-close-icon d-none d-lg-block" width="10" height="13">
                                        <use xlink:href="#discount-tiles-close-icon-lg"></use>
                                        </svg>`
                        });

                        $voucherRight.append($valueSection).append($removeButton);
                        $couponCard.append($voucherLeft).append($voucherMiddle).append($voucherRight);
                        $('.coupon-discount-row.applied').append($couponCard);
                    });
                }
                if (data.error) {
                    toastMessageHelper.showNotification('error', data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else if (ecomCouponCodeApplied) {
                    updateCartTotals(data);
                    $('#maincontent').trigger('cart:refreshCartSummary', {
                        isCartPage: true
                    });
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    toastMessageHelper.showNotification('success', data.message || 'ECOM Coupon applied successfully.');
                } else {
                    toastMessageHelper.showNotification('error', data.message || 'Failed to apply ECOM Coupon. Please try again.');
                }
                $('.coupon-code-field').val('');
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var urlParams = { code: couponCode, uuid: uuid };
        url = appendToUrl(url, urlParams);

        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove(); // remove coupon card
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $('body').trigger('promotion:success', data);
                toastMessageHelper.showNotification('success', 'Coupon removed successfully.');

                // Find and remove the card
                $('.coupon-discount-row.applied .discount-voucher-card').each(function () {
                    var $card = $(this);
                    if ($card.data('code') === couponCode) {
                        $card.fadeOut(200, function () {
                            $card.remove();
                            // $(`#voucher-${adjID}`).remove();

                            // Update total price after removal
                            // $('.total-price').empty().text(resp.totalProductValue);
                        });
                    }
                });

                // Remove prepaid gift voucher cards from the UI to keep in sync with backend
                $('.prepaid-gift-discount-row.applied .discount-voucher-card').fadeOut(200, function () {
                    $(this).remove();
                });

                $('#maincontent').trigger('cart:resetLoyalityPoints', data);
                $('#maincontent').trigger('cart:refreshCartSummary', {
                    isCartPage: true
                });
                $('.benefit-box').removeClass('selected');
                $('.redeemed-section, .protection-plan .benefits').removeClass('d-flex').addClass('d-none');
                $('.redeem-btn').removeClass('d-none').prop('disabled', true);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                }
            }
        });
    });

    /**
     * Loads available pickup slots for a given store ID via an AJAX request.
     *
     * @param {string} storeId - The unique identifier of the store to fetch slots for.
     *
     * @returns {void} - Updates the DOM with the retrieved slot options and resets the selected value text.
     */
    function loadSlots(storeId) { // Reusable function to load slots
        $.ajax({
            url: 'PickUpAtShowRoom-GetSlots',
            method: 'GET',
            data: { storeID: storeId },
            success: function (html) {
                $('#pickupSlot').html(html);
                $('.pis-selected-value').each(function () {
                    var $this = $(this);
                    var altText = $this.data('alttext');
                    $this.text(altText || '');
                });
            }
        });
    }

    /**
      * Updates the DOM with available pickup time slots based on
      * selected store, customer details, and pickup date.
      *
      * - Sends pickup selection data to the server
      * - Updates pickup slot HTML in the DOM on success
      * - Shows or hides the pickup slot section based on response
      *
      * @function updateTimeSlots
      * @returns {void}
      */
    function updateTimeSlots() {
        var selectedValue = $('input[name="storeSelect"]:checked').val();
        var customerPhone = $('.customerPhone').val();
        var customerEmail = $('.customerEmail').val();
        var selectedDate = $('#pickupDate').val();
        var uuid = $('.save-selection').data('uuid');
        var url = $('#pickUpAtShowRoomTimeDropdown').data('url');
        var selectedValueText = $('.pis-selected-value').attr('data-value');

        var tryatshowroomData = {
            storeID: selectedValue,
            customerPhone: customerPhone,
            customerEmail: customerEmail,
            selectedDate: selectedDate,
            uuid: uuid,
            selectedSlot: selectedValueText && selectedValueText !== 'null' ? selectedValueText : ''
        };

        $.ajax({
            url: url,
            method: 'POST',
            data: tryatshowroomData,
            success: function (data) {
                if (data.success === false) {
                    $('#bopisForm .pickup-slot-scroll').addClass('d-none');
                } else {
                    $('#bopisForm .pickup-slot-scroll').removeClass('d-none');
                    $('#pickupSlot').html(data);
                }
            }
        });
    }

    /**
     * Event listener for store selection change.
     *
     * When a user selects a different store (radio button input with name "storeSelect"),
     * this handler retrieves the store ID and triggers the slot loading process.
     *
     * @event change
     * @param {Event} e - The change event object triggered when the store is changed.
     *
     * @returns {void}
     */
    $(document).on('change', '#bopisModal input[name="storeSelect"]', function () { // BOPIS: Update slots when store is changed
        var storeId = $(this).val();
        // loadSlots(storeId);
        var minimumTransitDays = $(this).data('min-transit-days');
        // Set pickup date to today when store is selected
        var $dateInput = $('#bopisModalContainer').find('.bopis-form-date-input');
        if ($dateInput.length) {
            var minDate = new Date();

            if (minimumTransitDays) {
                minDate.setDate(minDate.getDate() + parseInt(minimumTransitDays, 10));
            }

            // Get holiday data
            var holidaysData = $('#pickUpAtShowroomHolidaysData').val();
            var allHolidayData = holidaysData ? JSON.parse(holidaysData) : {};
            var holidays = [];

            // Add common holidays
            if (allHolidayData && allHolidayData.commonHolidays && Array.isArray(allHolidayData.commonHolidays)) {
                holidays = holidays.concat(allHolidayData.commonHolidays);
            }

            // Add store specific holidays
            if (storeId && allHolidayData.showroomHolidays && Array.isArray(allHolidayData.showroomHolidays)) {
                var selectedStoreHolidays = allHolidayData.showroomHolidays.find(function (store) {
                    return store.storeId === storeId;
                });
                if (selectedStoreHolidays && selectedStoreHolidays.holidays && Array.isArray(selectedStoreHolidays.holidays)) {
                    holidays = holidays.concat(selectedStoreHolidays.holidays);
                }
            }

            var holidaysSet = {};
            holidays.forEach(function (date) {
                holidaysSet[date] = true;
            });

            // Check if minDate is a holiday and advance until a valid date is found
            var safetyCounter = 0;
            while (safetyCounter < 365) {
                var day = ('0' + minDate.getDate()).slice(-2);
                var month = ('0' + (minDate.getMonth() + 1)).slice(-2);
                var year = minDate.getFullYear();
                var dateString = day + '/' + month + '/' + year;

                if (holidaysSet[dateString]) {
                    minDate.setDate(minDate.getDate() + 1);
                    safetyCounter++;
                } else {
                    break;
                }
            }

            if ($dateInput.data('datepicker')) {
                $dateInput.datepicker('setStartDate', minDate);
                $dateInput.datepicker('setDate', minDate);
                // Refresh datepicker so disabled dates update per selected store
                $dateInput.datepicker('update');
            } else {
                var d = ('0' + minDate.getDate()).slice(-2);
                var m = ('0' + (minDate.getMonth() + 1)).slice(-2);
                var y = minDate.getFullYear();
                $dateInput.val(d + '/' + m + '/' + y);
            }

            // Trigger change so dependent UI (slot selection/validation) stays in sync
            $dateInput.trigger('change');
        }
    });

    $(document).on('click', '#pickUpAtShowRoomTimeDropdown', function () {
        if (!$('#pickUpAtShowRoomTimeDropdown').hasClass('opened')) {
            var selectedValue = $('input[name="storeSelect"]:checked').val();
            var customerPhone = $('.customerPhone').val();
            var customerEmail = $('.customerEmail').val();
            var selectedDate = $('#pickupDate').val();
            var uuid = $('.save-selection').data('uuid');
            var url = $(this).data('url');
            var selectedValueText = $('.pis-selected-value').attr('data-value');

            if (!selectedValue) {
                $('#bopisForm .pickup-slot-scroll').addClass('d-none');
                $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').addClass('is-invalid');
                $('.invalid-pis-pickupslot').addClass('d-none').removeClass('d-block');
                $('.not-available-pis-pickupslot').addClass('d-none').removeClass('d-block');
                $('.missing-pis-select-store').removeClass('d-none').addClass('d-block');
                return;
            }

            var tryatshowroomData = {
                storeID: selectedValue,
                customerPhone: customerPhone,
                customerEmail: customerEmail,
                selectedDate: selectedDate,
                uuid: uuid,
                selectedSlot: selectedValueText && selectedValueText !== 'null' ? selectedValueText : ''
            };
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: tryatshowroomData,
                success: function (data) { // eslint-disable-line no-unused-vars
                    $.spinner().stop();
                    if (data.success === false) {
                        $('#bopisForm .pickup-slot-scroll').addClass('d-none');
                        $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').addClass('is-invalid');
                        $('.invalid-pis-pickupslot').addClass('d-none').removeClass('d-block');
                        $('.missing-pis-select-store').addClass('d-none').removeClass('d-block');
                        $('.not-available-pis-pickupslot').removeClass('d-none').addClass('d-block');
                    } else {
                        $('#bopisForm .pickup-slot-scroll').removeClass('d-none');
                        $('#pickupSlot').html(data);
                        $('#bopisForm .pickup-slot-scroll').scrollTop(0);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
    /**
     * Event listener for deleting a BOPIS selection.
     *
     * When the user clicks on an element with the class "delete-selection", this handler:
     *  - Sends an AJAX POST request to delete the saved selection using its UUID.
     *  - Resets the CTA (Call To Action) button to its default state.
     *  - Clears all modal fields (store selection, date, slot, selected value).
     *  - Closes the BOPIS modal.
     *
     * @event click
     * @param {Event} e - The click event object triggered when "delete-selection" is clicked.
     *
     * @returns {void}
     */
    $(document).on('click', '.delete-selection', function () { // BOPIS: Delete selection and reset form
        var uuid = $('.save-selection').data('uuid');
        var url = $(this).data('url');
        $.ajax({
            url: url,
            method: 'POST',
            data: { uuid: uuid },
            success: function (response) {
                if (response.success) {
                    // Reset modal fields
                    $('input[name="storeSelect"]').prop('checked', false);
                    $('#pickupDate, #pickupSlot, #selectedPickupSlot').val('');
                    $('.pickup-from-showroom-btn[data-uuid="' + uuid + '"]').removeClass('selected').find('.green-tick-mark').addClass('d-none')
                        .find('use')
                        .attr('xlink:href', '');

                    // Cache the element and get its alt text
                    var $sel = $('.pis-selected-value');
                    var altText = $sel.attr('data-alttext') || $sel.data('alttext') || 'Choose...';
                    $sel.text(altText);

                    $('#maincontent').trigger('cart:refreshCartSummary', {
                        isCartPage: true
                    });

                    // Close modal
                    $('#bopisModal').modal('hide');
                }
            }
        });
    });

    /**
     * Event listener for saving a BOPIS selection.
     *
     * When the user clicks on an element with the class "save-selection", this handler:
     *  - Retrieves the selected store, pickup date, and pickup slot.
     *  - Falls back to the visible `.selected-value` text if no slot value is set,
     *    while treating "null" or "Choose..." as empty values.
     *  - Validates that both date and slot are selected; otherwise, shows validation errors.
     *  - Sends an AJAX POST request to save the selection (store, date, slot, and uuid).
     *  - On success, marks the CTA button as "selected" and closes the modal.
     *
     * @event click
     * @param {Event} e - The click event object triggered when "save-selection" is clicked.
     *
     * @returns {void}
     */
    $(document).on('click', '.save-selection', function () { // BOPIS: Save selection (store, date, slot)
        var store = $('input[name="storeSelect"]:checked').val();
        var date = $('#pickupDate').val();
        var slot = $('#selectedPickupSlot').val();
        var uuid = $('.save-selection').data('uuid');
        var $scrollContainer = $('#bopisForm');
        var $slotErrorDisplay = $('.invalid-pis-pickupslot');
        var url = $(this).data('url');

        var $scrollTarget = null;

        // If slot is empty, but a value is shown in .selected-value, use that (but treat 'null' as empty)
        if (!slot) {
            var selectedText = $('.pis-selected-value').text().trim();
            if (selectedText && selectedText !== 'Choose...' && selectedText !== 'null') {
                slot = selectedText;
                $('#selectedPickupSlot').val(slot); // sync hidden input
            } else if (selectedText === 'null') {
                slot = '';
                $('#selectedPickupSlot').val('');
            }
        }

        if (!slot) {
            $slotErrorDisplay.removeClass('d-none').addClass('d-block');
            $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').addClass('is-invalid');
            $('.not-available-pis-pickupslot, .missing-pis-select-store').addClass('d-none').removeClass('d-block');
            if (!$scrollTarget) {
                $scrollTarget = $slotErrorDisplay.first();
            }
        }

        // Show both errors if both are missing
        var requestSubmitted = false;
        var $dateError = $('.invalid-pis-pickupdate');
        var $slotErrorMsg = $('.pis-form-control').data('dismiss');

        if (!date && !slot) {
            $dateError.text($slotErrorMsg);
            $('#bopisForm .date-picker ').addClass('is-invalid');
            $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').addClass('is-invalid');
            $slotErrorDisplay.removeClass('d-none').addClass('d-block');
            $scrollTarget = $dateError.first();
        } else if (!date) {
            $dateError.text($slotErrorMsg);
            $('#bopisForm .date-picker ').addClass('is-invalid');
            $scrollTarget = $dateError.first();
        } else if (!slot) {
            $('.not-available-pis-pickupslot, .missing-pis-select-store').addClass('d-none').removeClass('d-block');
            $slotErrorDisplay.removeClass('d-none').addClass('d-block');
            $scrollTarget = $slotErrorDisplay.first();
        } else {
            requestSubmitted = true;
            $.spinner().start();
            var requestData = {
                uuid: uuid,
                storeSelect: store,
                pickupDate: date,
                pickupSlot: slot
            };
            $.ajax({
                url: url,
                method: 'POST',
                data: requestData,
                success: function (response) {
                    $.spinner().stop();
                    if (response.success) {
                        $('.pickup-from-showroom-btn[data-uuid="' + uuid + '"]').addClass('selected').find('.green-tick-mark').removeClass('d-none')
                            .find('use')
                            .attr('xlink:href', '#success-svg-icon');
                        $('#bopisModal').modal('hide');

                        $('#maincontent').trigger('cart:refreshCartSummary', {
                            isCartPage: true
                        });
                    } else {
                        var message = $('#openBopisBtn').data('error');
                        toastMessageHelper.showNotification(message || 'An error occurred while saving your selection. Please try again.');
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
        if (!requestSubmitted && $scrollTarget && $scrollTarget.length) {
            $scrollContainer.animate({
                scrollTop: $scrollContainer.scrollTop() + $scrollTarget.position().top - (-390)
            }, 500);
        }
    });

    /**
     * Event listener for pickup date change.
     *
     * When the user selects or changes the pickup date, this handler:
     *  - Checks if a valid date value is entered.
     *  - Hides the pickup date error message (`.invalid-pis-pickupdate`) if a value exists.
     *
     * @event change
     * @param {Event} e - The change event object triggered when the pickup date field changes.
     *
     * @returns {void}
     */
    $(document).on('change', '#pickupDate', function () {
        if ($(this).val().trim() === '') {
            $('#bopisForm .date-picker ').addClass('is-invalid');
            $('.invalid-pis-pickupdate').text($('.pis-form-control').data('dismiss'));
            return;
        }

        if ($(this).val().trim()) {
            // Hide date error
            $('#bopisForm .date-picker ').removeClass('is-invalid');
            $('.invalid-pis-pickupdate').text('');
            $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').removeClass('is-invalid');
            $('.invalid-pis-pickupslot, .not-available-pis-pickupslot, .missing-pis-select-store').addClass('d-none').removeClass('d-block');

            // Reset slot section to default state
            $('#selectedPickupSlot').val(''); // clear hidden slot
            $('.pickup-slot-scroll .custom-option-value').removeClass('selected time-slot-value-highlight'); // remove highlights

            // Reset visible span text
            const $sel = $('.pis-selected-value');
            const altText = $sel.attr('data-alttext') || $sel.data('alttext') || 'Choose...';
            $sel.text(altText)
                .attr('data-value', 'null')
                .attr('data-slot', 'default');
        }

        // Refresh the DOM time slots based on the new date selection
        updateTimeSlots();
    });

    /**
     * Event listener for selecting a BOPIS time slot.
     *
     * When a user clicks on an element with the class "time-slot-value", this handler:
     *  - Ignores the click if the slot has the "strick-out" class (inactive/unavailable).
     *  - Stores the selected slot ID in the hidden input field `#selectedPickupSlot`.
     *  - Hides the pickup slot error message (`.invalid-pis-pickupslot`) if it was previously shown.
     *
     * @event click
     * @param {Event} e - The click event object triggered when a time slot is clicked.
     *
     * @returns {void}
     */
    $(document).on('click', '.time-slot-value', function () { // BOPIS: Select time slot & hide error
        if ($(this).hasClass('strick-out')) {
            $('.time-slot-select').find('.down-arrow').removeClass('rotate-arrow');
            return; // ignore inactive slots
        }

        var selectedSlot = $(this).data('id');
        $('#selectedPickupSlot').val(selectedSlot);

        // hide error if previously shown
        $('.invalid-pis-pickupslot').addClass('d-none').removeClass('d-block');
        $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').removeClass('is-invalid');
    });

    /**
     * Event listener for opening the BOPIS modal.
     *
     * When the user clicks the "openBopisBtn", this handler:
     *  - Retrieves the UUID and URL from the button's data attributes.
     *  - Sends an AJAX GET request to fetch ISML-rendered modal content.
     *  - Injects the response into `#bopisModalContainer`.
     *  - If a store is already selected:
     *      - Calls `loadSlots()` if the slot status is set to "default".
     *      - Otherwise, loads slots for the selected store via a direct AJAX call.
     *  - Initializes the datepicker inside the modal with custom settings:
     *      - Format: dd/mm/yyyy
     *      - Start date restricted to today
     *      - Week starts on Monday
     *      - Short day names
     *      - Disabled prev/next text
     *  - Finally, displays the modal (`#bopisModal`).
     *
     * @event click
     * @param {Event} e - The click event object triggered when the open button is clicked.
     *
     * @returns {void}
     */
    $(document).on('click', '#openBopisBtn', function () { // BOPIS: Open modal and load ISML content
        if (isPickUpFromShowroomRequestActive) {
            return;
        }

        var bopisModal = $('#bopisModal');
        if (bopisModal.length && bopisModal.hasClass('show')) {
            return;
        }

        isPickUpFromShowroomRequestActive = true;

        var uuid = $(this).data('uuid');
        var url = $(this).data('url');

        $.ajax({
            url: url,
            data: { uuid: uuid },
            type: 'get',
            success: function (response) {
                $('#bopisModalContainer').html(response);
                var holidaysData = $('#pickUpAtShowroomHolidaysData').val();
                var allHolidayData = holidaysData ? JSON.parse(holidaysData) : {};

                // Datepicker initialization
                var $dateInput = $('#bopisModalContainer').find('.bopis-form-date-input');
                if ($dateInput.length) {
                    /**
                     * Get holidays for currently selected store
                     * @returns {Object} Object with holiday dates as keys
                     */
                    var getHolidaysForSelectedStore = function () {
                        var holidays = [];

                        // Always add common holidays
                        if (allHolidayData && allHolidayData.commonHolidays && Array.isArray(allHolidayData.commonHolidays)) {
                            holidays = holidays.concat(allHolidayData.commonHolidays);
                        }

                        // Get selected store ID
                        var selectedStoreId = $('input[name="storeSelect"]:checked').val();

                        if (selectedStoreId && allHolidayData.showroomHolidays && Array.isArray(allHolidayData.showroomHolidays)) {
                            // Find holidays for the selected store
                            var selectedStoreHolidays = allHolidayData.showroomHolidays.find(function (store) {
                                return store.storeId === selectedStoreId;
                            });

                            if (selectedStoreHolidays && selectedStoreHolidays.holidays && Array.isArray(selectedStoreHolidays.holidays)) {
                                holidays = holidays.concat(selectedStoreHolidays.holidays);
                            }
                        }

                        // Convert to Set for faster lookup
                        var holidaysSet = {};
                        holidays.forEach(function (date) {
                            holidaysSet[date] = true;
                        });

                        return holidaysSet;
                    };

                    $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                    $dateInput
                        .datepicker('destroy')
                        .datepicker({
                            format: 'dd/mm/yyyy',
                            language: 'en',
                            autoclose: true,
                            todayHighlight: false,
                            startDate: '+0d',
                            weekStart: 1,
                            maxViewMode: 2,
                            beforeShowDay: function (date) {
                                var holidaysSet = getHolidaysForSelectedStore();

                                // Format date to DD/MM/YYYY to match holiday format
                                var day = ('0' + date.getDate()).slice(-2);
                                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                                var year = date.getFullYear();
                                var dateString = day + '/' + month + '/' + year;

                                // Disable the date if it's a holiday
                                var isHoliday = holidaysSet[dateString] === true;
                                return !isHoliday;
                            }
                        })
                        .on('show', function (e) { e.stopPropagation(); });

                    // Set today's date only if input is empty
                    if ($dateInput.val() === '') {
                        $dateInput.datepicker('setDate', new Date());
                    }

                    $dateInput.on('click', function () {
                        $('.table-condensed .prev').text('');
                        $('.table-condensed .next').text('');
                    });
                }

                // Load slots if store selected
                var checkedInput = $('input[name="storeSelect"]:checked');
                var selectedStoreId;
                if (checkedInput.val()) {
                    selectedStoreId = checkedInput.val();
                }
                var slotStatus = $('.pis-selected-value').data('slot');
                if (checkedInput.length) {
                    if (slotStatus === 'default') loadSlots(checkedInput.val());
                    else {
                        $.ajax({
                            url: 'PickUpAtShowRoom-GetSlots',
                            method: 'GET',
                            data: { storeID: checkedInput.val(), selectedStoreId: selectedStoreId, uuid: uuid },
                            success: function (html) { $('#pickupSlot').html(html); }
                        });
                    }
                }

                // Show modal initially
                $('#bopisModal').modal('show');

                // Responsive modal handling
                var isModalOpen = true;

                // Track previous breakpoint state (true = desktop, false = mobile)
                var wasDesktop = $(window).width() >= 1024;
                /**
                 * Handles window resize and orientation change events for the BOPIS modal.
                 *
                 * This function checks if the viewport crosses the desktop/mobile breakpoint (1024px).
                 * If the modal is open and the breakpoint changes, it automatically closes the modal.
                 * It also updates the previous breakpoint state (`wasDesktop`) for future comparisons.
                 *
                 * @returns {void}
                */
                function handleResize() {
                    var isDesktop = $(window).width() >= 1024;

                    if ($dateInput && $dateInput.length) {
                        $dateInput.datepicker('hide');
                    }

                    // Close modal on ANY breakpoint cross (desktop <-> mobile), if open
                    // Original only handled desktop -> mobile; now symmetric for mobile -> desktop too
                    if (wasDesktop !== isDesktop && isModalOpen) {
                        $('#bopisModal').modal('hide');
                    }

                    // Update previous state
                    wasDesktop = isDesktop;
                }

                // Bind resize & orientationchange
                $(window).off('resize.bopis orientationchange.bopis').on('resize.bopis orientationchange.bopis', handleResize);

                // Track modal state on show/hide
                $('#bopisModal').off('shown.bopis hidden.bopis')
                    .on('shown.bopis', function () { isModalOpen = true; })
                    .on('hidden.bopis', function () {
                        isModalOpen = false;
                        // Remove listeners to prevent duplicates
                        $(window).off('resize.bopis orientationchange.bopis');
                    });
            },
            complete: function () {
                isPickUpFromShowroomRequestActive = false;
            }
        });
    });

    /**
     * Custom click for BOPIS time slots
     */
    $(document).on('click', '.pickup-slot-scroll .custom-option-value', function () {
        let optionValue = $(this);

        if (optionValue.is('[disabled]') || optionValue.hasClass('strick-out')) return;

        // Remove 'selected' class from all and add to clicked one
        $('.pickup-datetime-container').find('.custom-option-value').removeClass('selected');
        optionValue.addClass('selected');

        // Remove highlight from all time slots
        $('.time-slot-value').removeClass('time-slot-value-highlight');

        // Optionally, add highlight to the clicked slot
        optionValue.addClass('time-slot-value-highlight');

        const selectedText = optionValue.text().trim();
        const selectedId = optionValue.data('id');

        // Update hidden field
        $('#selectedPickupSlot').val(selectedId);

        // Update visible text
        $('.pis-selected-value')
            .text(selectedText)
            .attr('data-value', selectedId)
            .attr('data-slot', 'selected');

        // Hide validation message if visible
        $('.invalid-pis-pickupslot').addClass('d-none').removeClass('d-block');
        $('#pickUpAtShowRoomTimeDropdown .custom-drop-down').removeClass('is-invalid');
    });

    $('#maincontent').on('input', '#discountVoucherCode, #couponCode, #pgvCode', function () {
        var $el = $(this);
        var val = $.trim($el.val());

        if (val.length > 0) {
            if ($el.attr('id') === 'discountVoucherCode') {
                $('.discount-voucher-error').removeClass('d-inline-block');
            }
            if ($el.attr('id') === 'couponCode') {
                $('.coupon-missing-error').hide();
            }
            if ($el.attr('id') === 'pgvCode') {
                $('.pgv-missing-error').removeClass('d-inline-block');
            }
        }
    });

    $('#maincontent').on('cart:updateTotals', function (e, data) {
        updateCartTotals(data);
        updateApproachingDiscounts(data.approachingDiscounts);
        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        validateBasket(data);
    });

    $('#maincontent').on('cart:resetRPPUI', function () {
        var $openPlans = $('.open-plans.plans-section');
        $('.redeem-btn').removeClass('d-none').prop('disabled', true);
        $('.open-status-redeem-btn, .plan-footer .see-benefits, #rateProtectionPlanModal .matured-plans').add($openPlans.find('.see-benefits')).removeClass('d-none');
        $('.redeemed-section, .protection-plan .benefits').add($openPlans.find('.benefits')).removeClass('d-flex').addClass('d-none');
        $('.benefit-box').removeClass('selected');
        $('.plan-card').each(function () {
            var $card = $(this);
            var planId = $card.attr('data-plan-id');
            if (planId && $card.find('.benefit-box').length > 0) {
                $card.find('.benefit-box').removeClass('btndisabled redeemed');
            }
        });
        $('#rateProtectionPlanModal .tab-btn').removeClass('active');
        $('#rateProtectionPlanModal .tab-btn[data-target=".matured-plans"]').addClass('active');
        $('#rateProtectionPlanModal .plans-section, .plan-footer .close-benefits').add($openPlans.find('.close-benefits')).addClass('d-none');
        $openPlans.find('.open-status-redeem-btn').not('.no-plan-benefits').prop('disabled', true);
    });

    base.selectAttribute();
    base.colorAttribute();
};

/**
 * Initializes the PDP recommendation Slick carousel.
 *
 * @function
 * @name slickCarousel
 * @return {undefined}
 */
function slickCarousel() {
    // Remove only direct slide divs that contain <wainclude>
    $('.cart-slick-carousel, .cart-slicker').children('.col-12').has('wainclude').remove();
    $('.cart-slick-carousel, .cart-slicker').slick({
        slidesToShow: 2.58,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

slickCarousel();

$(document).ready(function () {
    var inventoryfailed = $('.inventoryfailed-message').val();
    if ($('.inventoryfailed-message').hasClass('inventoryfailed-message')) {
        toastMessageHelper.showNotification(inventoryfailed);
    }
});
